module.exports = __webpack_public_path__ + "static/Cottage-Grove-Party-Contract_2025-03-68cf8e683dae94774f0a4bd584def0bf.pdf";